import { render, staticRenderFns } from "./SabbaticalLeaveRequestList.vue?vue&type=template&id=863c1e52&scoped=true&"
import script from "./SabbaticalLeaveRequestList.vue?vue&type=script&lang=js&"
export * from "./SabbaticalLeaveRequestList.vue?vue&type=script&lang=js&"
import style0 from "./SabbaticalLeaveRequestList.vue?vue&type=style&index=0&id=863c1e52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "863c1e52",
  null
  
)

export default component.exports